import { createSlice } from "@reduxjs/toolkit";
import { newsStateName, newsInitialState } from "./constants";

const newsSlice = createSlice({
  name: newsStateName,
  initialState: newsInitialState,
  reducers: {
    setNews(state, action) {
      state.news = action.payload;
    },
  },
});

export const { name, reducer, actions } = newsSlice;
